/**
 * Saving a file the SPA already holds in memory — one implementation.
 *
 * Two surfaces need it (the roster CSV built in the browser and the grades
 * CSV the backend streams, PRD-61 §FR-4), and both used to repeat the same
 * `createObjectURL` → hidden `<a download>` → click → revoke dance.
 */

/**
 * The filename from a `Content-Disposition` header, or `null` when there is
 * none. `filename*=UTF-8''…` (RFC 5987) wins because the backend emits that
 * form for every non-ASCII name ("Matemáticas 2°A – Parcial 2 – 2025-2026.csv");
 * the legacy `filename="…"` is the fallback. The caller owns the default,
 * because only it knows what the file is (and can translate the name).
 */
export function filenameFromContentDisposition(header: string | undefined): string | null {
  if (!header) return null
  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1])
    } catch {
      return utf8Match[1]
    }
  }
  const asciiMatch = header.match(/filename="?([^";]+)"?/i)
  return asciiMatch?.[1] ?? null
}

/** Hand a blob to the browser's save dialog under `filename`. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.append(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
